/**
 * 미출석 모니터링 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { BellAlertIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const mockAbsentees = [
  { id: '1', student_name: '최동욱', expected_time: '09:00', elapsed_time: 25, phone: '010-1234-5678' },
  { id: '2', student_name: '정수진', expected_time: '10:00', elapsed_time: 15, phone: '010-2345-6789' },
];

const DemoAttendanceMonitoringPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="미출석 모니터링 (데모)" currentIcon={BellAlertIcon} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-2xl font-bold">미출석 알림</h2>
          </div>
          <div className="p-6">
            {mockAbsentees.length === 0 ? (
              <div className="text-center py-12 text-gray-500">현재 미출석 학생이 없습니다.</div>
            ) : (
              <div className="space-y-4">
                {mockAbsentees.map((absentee) => (
                  <div key={absentee.id} className="border-l-4 border-orange-500 bg-orange-50 p-4 rounded">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="font-semibold text-lg">{absentee.student_name}</h3>
                        <p className="text-sm text-gray-600">
                          예상 시간: {absentee.expected_time} | 경과 시간: {absentee.elapsed_time}분
                        </p>
                        <p className="text-sm text-gray-600">연락처: {absentee.phone}</p>
                      </div>
                      <button
                        disabled
                        className="px-4 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed"
                      >
                        알림 발송
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="mt-6 text-center text-gray-500 text-sm">
              📢 데모 모드에서는 알림 발송이 불가능합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoAttendanceMonitoringPage;
